import React from 'react';

import ProUpgradePromo from './ProUpgradePromo';

const DesktopNonProSubscriberContent = () => (
  <div className="hidden flex-col items-center md:flex">
    <ProUpgradePromo />
  </div>
);

export default DesktopNonProSubscriberContent;
